import { useMemo } from 'react';
import { useFreshdeskContextState } from 'store';

const useIsEntityIconVisible = () => {
  const { getUiControlsConfigs } = useFreshdeskContextState();

  return useMemo(() => getUiControlsConfigs()?.entityList?.table?.columns?.icon?.visible !== false, [getUiControlsConfigs]);
};

export default useIsEntityIconVisible;
